// extracted by mini-css-extract-plugin
export default {"input-header":"Input_input-header__mmxCR","input-error-label":"Input_input-error-label__FkVtq","invalid-input":"Input_invalid-input__w2GVL"};